import {PaginationQueryParams} from './pagination-query-params';

export interface ItemsQueryParams extends PaginationQueryParams {
  by_name?: string;
  active?: boolean;
  list: 'summary';
  catalog_id?: number;
  organization_id?: string;
  exclude_catalog_id?: number;
}

export interface ListBundlesParams extends Partial<PaginationQueryParams> {
  by_name?: string;
  active?: boolean;
  catalog_id?: number;
  exclude_catalog_id?: number;
  organization_id?: string;
}

export const DEFAULT_ITEM_QUERY_PARAMS: ItemsQueryParams = {
  page: 1,
  per_page: 10,
  list: 'summary',
};
